<template>
  <div>
    <el-dialog title="已选择商品" :visible.sync="visible" :close-on-click-modal="false" width="80%">
      <div style="margin-bottom: 16px">
        <el-button size="mini" type="primary" @click="showAddCategories">批量添加分类</el-button>
        <el-button size="mini" type="danger" @click="showRemoveCategories">批量移除分类</el-button>
      </div>
      <el-table
        :data="selectedRows"
        highlight-current-row
        border
        stripe
        size="mini"
        max-height="500px"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="sku" label="款号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="cats" label="分类" width="300">
          <template slot-scope="scope">
            <el-popover
              v-for="(cats, index) in scope.row.cats"
              :key="index"
              placement="top"
              trigger="hover"
            >
              <div>
                <span v-for="(cat, i) in cats" :key="cat.id"
                  >{{ cat.name }} <span v-if="i < cats.length - 1">&nbsp;&gt;&nbsp;</span></span
                >
              </div>
              <el-tag
                slot="reference"
                size="mini"
                effect="dark"
                style="margin-right: 5px; margin-bottom: 5px"
              >
                {{ cats[cats.length - 1].name }}
              </el-tag>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="images" label="图片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.image"
              :src="scope.row.image"
              :preview-src-list="scope.row.images"
              fit="cover"
              style="width: 50px; height: 50px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">上架</span>
            <span v-else-if="scope.row.status === 2">下架</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="新增分类"
      :visible.sync="addCategoriesFormVisible"
      :close-on-click-modal="false"
    >
      <div style="margin: 20px">
        <el-alert title="将会为已选中的商品添加相应分类" type="warning" />
      </div>
      <el-form ref="addCategoriesForm" :model="addCategoriesForm" label-width="120px">
        <el-form-item label="分类">
          <el-cascader
            v-model="addCategoriesForm.catIds"
            style="width: 550px"
            :options="categories"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: true,
              checkStrictly: false,
            }"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCategoriesFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addCategoriesSubmit">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="移除分类"
      :visible.sync="removeCategoriesFormVisible"
      :close-on-click-modal="false"
    >
      <div style="margin: 20px">
        <el-alert title="将会为已选中的商品移除相应分类" type="warning" />
      </div>
      <el-form ref="removeCategoriesForm" :model="removeCategoriesForm" label-width="120px">
        <el-form-item label="分类">
          <el-cascader
            v-model="removeCategoriesForm.catIds"
            style="width: 550px"
            :options="categories"
            filterable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: true,
              checkStrictly: false,
            }"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="removeCategoriesFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="removeCategoriesSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedRows: [],
      visible: false,

      categories: [],

      addCategoriesFormVisible: false,
      addCategoriesForm: {
        catIds: null,
      },

      removeCategoriesFormVisible: false,
      removeCategoriesForm: {
        catIds: null,
      },
    };
  },
  methods: {
    async show(selectedRows) {
      this.selectedRows = selectedRows;
      this.addCategoriesForm = {};
      this.visible = true;
    },
    close() {
      this.$emit("success");
      this.visible = false;
    },

    async showAddCategories() {
      this.categories = await this.axios.get("mall:/api/admin/product-category/tree");
      this.addCategoriesForm = {};
      this.addCategoriesFormVisible = true;
    },
    async addCategoriesSubmit() {
      if (!this.addCategoriesForm.catIds || !this.addCategoriesForm.catIds.length) {
        this.$notify.error("请先选择要添加的分类");
        return;
      }
      const productIds = [];
      for (let i = 0; i < this.selectedRows.length; i++) {
        productIds.push(this.selectedRows[i].id);
      }
      const catIds = [];
      for (let i = 0; i < this.addCategoriesForm.catIds.length; i++) {
        const ids = this.addCategoriesForm.catIds[i];
        catIds.push(ids[ids.length - 1]);
      }
      await this.axios.post("mall:/api/admin/product/addCategories", {
        productIds: productIds,
        catIds: catIds,
      });
      this.$notify.success("操作成功");
      this.addCategoriesFormVisible = false;
      this.close();
    },
    async showRemoveCategories() {
      this.categories = await this.axios.get("mall:/api/admin/product-category/tree");
      this.removeCategoriesForm = {};
      this.removeCategoriesFormVisible = true;
    },
    async removeCategoriesSubmit() {
      if (!this.removeCategoriesForm.catIds || !this.removeCategoriesForm.catIds.length) {
        this.$notify.error("请先选择要添加的分类");
        return;
      }
      const productIds = [];
      for (let i = 0; i < this.selectedRows.length; i++) {
        productIds.push(this.selectedRows[i].id);
      }
      const catIds = [];
      for (let i = 0; i < this.removeCategoriesForm.catIds.length; i++) {
        const ids = this.removeCategoriesForm.catIds[i];
        catIds.push(ids[ids.length - 1]);
      }
      await this.axios.post("mall:/api/admin/product/removeCategories", {
        productIds: productIds,
        catIds: catIds,
      });
      this.$notify.success("操作成功");
      this.removeCategoriesFormVisible = false;
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
